import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';
import { Dispatch } from 'redux';
// @ts-ignore used for json-ptd
import jsonptd from '../lib/json-ptd/json-ptd';
import { requestsActions } from './requests';
import typelib from '../lib/json-ptd/typelib.json';

interface ConfigTypes {
    companyId: number | null,
    zamowieniaServiceAddress: string,
    ISODDomain: string,
    ISODURL: string,
    isOnLocalHost: boolean,
    brandColor: string,
    brandLightColor: string,
    brandBrightColor: string,
    tableFontColor: string,
    promotion: string,
    isPlateCreatorOn: boolean,
    isDebug: boolean,
    logo: string,
    menu: {
        news: boolean,
        orders: boolean,
        new_order: boolean,
        billings: boolean,
        promotion: boolean,
        isod: boolean,
        account: boolean,
        settings: boolean,
    },
    GutterCreatorURL: string,
    lang: string,
    gtmId: string,
}

interface CompanyType {
    companyId: number,
    serverName: string,
    zamowieniaServiceAddress: string,
    companyWebsite: string,
    logo: string,
    ISODDomain: string,
    ISODURL: string,
    brandColor: string,
    brandLightColor: string,
    brandBrightColor: string,
    tableFontColor: string,
    promotion: string,
    menu: {
        news: boolean,
        orders: boolean,
        new_order: boolean,
        billings: boolean,
        promotion: boolean,
        isod: boolean,
        account: boolean,
        settings: boolean,
    },
    isPlateCreatorOn: boolean,
    GutterCreatorURL: string,
    lang: string
}

interface ConfigNewTypes {
    config: {
        isOnLocalHost: boolean,
        isDebug: boolean,
        gtmId: string,
    },
    companies: CompanyType[]
}

const fetchConfig = () => fetch(`${process.env.PUBLIC_URL}/config.json`)
    .then((response) => response.json())
    .then((data) => data as ConfigNewTypes);

const fetchConfigWithTimeStamp = () => fetch(`${process.env.PUBLIC_URL}/config.json?timestamp=${Date.now()}`)
    .then((response) => response.json())
    .then((data) => data as ConfigNewTypes);

const confSlice = createSlice({
    name: 'conf',
    initialState: {
        companyId: null,
        zamowieniaServiceAddress: '',
        ISODDomain: '',
        ISODURL: '',
        isOnLocalHost: true,
        brandColor: '',
        brandLightColor: '',
        brandBrightColor: '',
        tableFontColor: '',
        promotion: '',
        isPlateCreatorOn: false,
        isDebug: false,
        logo: '',
        menu: {
            news: false,
            orders: false,
            new_order: false,
            billings: false,
            promotion: false,
            isod: false,
            account: false,
            settings: false
        },
        GutterCreatorURL: '',
        lang: 'PL',
        serviceWorks: [],
        gtmId: ''
    } as ConfigTypes,
    reducers: {
        setConfigState: (state, action: PayloadAction<ConfigTypes>) => (
            { ...state, ...action.payload }
        )
    }
});

export default confSlice.reducer;

const { setConfigState } = confSlice.actions;

export const setSliceState = (currentURL: string, currentCompany: number | null) => async (dispatch: Dispatch<any>) => {
    let result = await fetchConfig();

    if (!jsonptd.verify(result, 'config_new_types_type', typelib)) {
        result = await fetchConfigWithTimeStamp();
        if (!jsonptd.verify(result, 'config_new_types_type', typelib)) {
            dispatch(requestsActions.setIncorrectConfig(true));
            return;
        }
    }

    let company = _.filter(result.companies, ({ companyId, serverName }) => (currentCompany === null ? serverName.includes(currentURL) : companyId === currentCompany));

    company = company.length !== 0 ? company : [result.companies[0]];

    const res: ConfigTypes = {
        companyId: company[0].companyId,
        zamowieniaServiceAddress: company[0].zamowieniaServiceAddress,
        ISODDomain: company[0].ISODDomain,
        ISODURL: company[0].ISODURL,
        isOnLocalHost: result.config.isOnLocalHost,
        brandColor: company[0].brandColor,
        brandLightColor: company[0].brandLightColor,
        brandBrightColor: company[0].brandBrightColor,
        tableFontColor: company[0].tableFontColor,
        promotion: company[0].promotion,
        isPlateCreatorOn: company[0].isPlateCreatorOn,
        isDebug: result.config.isDebug,
        logo: company[0].logo,
        menu: company[0].menu,
        GutterCreatorURL: company[0].GutterCreatorURL,
        lang: company[0].lang,
        gtmId: result.config.gtmId
    };

    dispatch(setConfigState(res));
};
